import { ELeasePacketUrls } from 'data/urls/leasePacket.url';
import { EPropertyMangerUrl } from 'data/urls/propertyManager.url';
import { TLeasePacketAddendumUI } from 'data/types/leasePacket.types';
import { authSplitApi } from 'redux/helpers/slice.helpers';

const URL = `${EPropertyMangerUrl.PROPERTY_MANAGER}/${ELeasePacketUrls.LEASE_PACKET}`;
export const leasePacketApi = authSplitApi('leasePacket', ['leasePacketAddendum']).injectEndpoints({
  endpoints: (build) => ({
    getLeasePacketAddendum: build.query<TLeasePacketAddendumUI, string>({
      query(policyId) {
        return {
          url: `${URL}/${ELeasePacketUrls.ADDENDUM}`,
          method: 'GET',
          params: { policyId },
        };
      },
      providesTags: ['leasePacketAddendum'],
    }),
  }),
});

export const { useGetLeasePacketAddendumQuery, useLazyGetLeasePacketAddendumQuery } = leasePacketApi;
